const FIDO_METRIC_DAILY_SPLITS: Record<string, string> = {
  'fidodb.nuovi_iscritti': 'fidodb.mese_iscrizione',
  'fidodb.clienti_attivati': 'fidodb.mese_pagamento',
  'fidodb.clienti_paganti_periodo': 'fidodb.mese_iscrizione',
  'fidodb.cambio_commercialista': 'fidodb.mese_iscrizione',
  'fidodb.aperture_partita_iva': 'fidodb.mese_iscrizione',
};

const FIDO_METRIC_DATE_COLUMNS: Record<string, string> = {
  'fidodb.nuovi_iscritti': 'utente.creation_date',
  'fidodb.clienti_attivati': 'payment.payment_date',
  'fidodb.clienti_paganti_periodo': 'utente.creation_date',
  'fidodb.cambio_commercialista': 'utente.creation_date',
  'fidodb.aperture_partita_iva': 'utente.creation_date',
};

/** Split da usare nella query giornaliera KPI per una metrica DB. */
export function resolveDatabaseMetricDailySplit(
  metricKey: string,
  fallbackDateColumn: string | null = null,
): string | null {
  return (
    FIDO_METRIC_DAILY_SPLITS[metricKey] ||
    FIDO_METRIC_DATE_COLUMNS[metricKey] ||
    fallbackDateColumn
  );
}

/** Riconosce la chiave split data restituita dal backend per il grafico KPI. */
export function isDatabaseChartDateSplit(
  splitKey: string,
  metricKey: string,
  fallbackDateColumn: string | null = null,
): boolean {
  const dailySplit = resolveDatabaseMetricDailySplit(metricKey, fallbackDateColumn);
  const candidates = new Set(
    [
      splitKey,
      dailySplit,
      fallbackDateColumn,
      FIDO_METRIC_DAILY_SPLITS[metricKey],
      FIDO_METRIC_DATE_COLUMNS[metricKey],
      'fidodb.mese_iscrizione',
      'fidodb.mese_pagamento',
      'fidodb.mese_attivazione',
      'utente.creation_date',
      'payment.payment_date',
      'abbonamento.data_creazione',
      'abbonamento.data_attivazione',
    ]
      .filter(Boolean)
      .map((value) => String(value).toLowerCase()),
  );

  return candidates.has((splitKey || '').toLowerCase());
}
